
const Images = {
  logo: "/images/logo.png",
  logo_white: "/images/logo_white.png",
  heroImage: "/images/hero_img.webp",
  partners_img:"/images/partners_img.png",
  how_it_works_img:"/images/how_it_works_img.webp",
  testimonial_one:"/images/TangPalace.png",
  testimonial_two:"/images/RevivGhana.png",
  testimonial_three:"/images/cimaf.png",
  testimonial_four:"/images/fidelio.png",
  contactusimage: "/images/contactusimage.png",
//testter
  mtn_momo: "/images/mtn_momo.png",
  telecel_cash: "/images/telecel_cash.png",
  at_cash: "/images/at_cash.png",

  

}

export default Images;